import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=d8e93f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8e93f86"]])

export default __exports__